import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const InactiveAccount = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isAdmin");
    navigate("/login");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-2xl font-bold mb-4">{t("inactive_account.title")}</h1>
      <p className="text-gray-600 mb-6 text-center max-w-md">
        {t("inactive_account.description")}
      </p>
      <Button onClick={handleLogout}>{t("inactive_account.return_to_login")}</Button>
    </div>
  );
};

export default InactiveAccount;
